import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import PropTypes from 'prop-types';

import { modelOf } from '../../../prop-types';
import RecurringOrderStore from '../../../store/RecurringOrderStore';
import RecurringOrder from '../../../models/RecurringOrder';
import RecurringOrderForm from '../RecurringOrderForm';
import AddressStore from '../../../store/AddressStore';
import RequestState from '../../../types/RequestState';
import ContentForState from '../../loader/ContentForState';

@observer
export class MainRecurringOrder extends Component {
  state = {
    addressState: RequestState.NONE,
    optionsState: RequestState.NONE
  };

  componentDidMount() {
    this.maybeLoadAddresses();
    this.maybeLoadShippingOptions();
  }

  maybeLoadAddresses = () => {
    const { addressStore } = this.props;

    if (addressStore.state === RequestState.NONE) {
      addressStore.loadAddresses();
    }
  };

  maybeLoadShippingOptions = () => {
    const { recurringOrder, recurringOrderStore } = this.props;

    if (
      !recurringOrderStore.shippingOptions.get(recurringOrder.id) &&
      !recurringOrderStore.shippingOptionStates.get(recurringOrder.id)
    ) {
      recurringOrderStore.loadOrderShippingOptions(recurringOrder.id);
    }
  };

  render() {
    const {
      addressStore,
      recurringOrderStore,
      recurringOrder,
      onSubmit
    } = this.props;

    return (
      <ContentForState
        state={addressStore.state}
        forLoaded={() => {
          return (
            <RecurringOrderForm
              onSubmit={onSubmit}
              recurringOrder={recurringOrder}
              addresses={addressStore.addressArray}
              shippingOptions={recurringOrderStore.shippingOptions.get(
                recurringOrder.id
              )}
            />
          );
        }}
      />
    );
  }
}

MainRecurringOrder.propTypes = {
  addressStore: modelOf(AddressStore).isRequired,
  recurringOrderStore: modelOf(RecurringOrderStore).isRequired,
  recurringOrder: modelOf(RecurringOrder).isRequired,
  onSubmit: PropTypes.func.isRequired,
  loading: PropTypes.bool
};

export default inject('addressStore', 'recurringOrderStore')(
  MainRecurringOrder
);



// WEBPACK FOOTER //
// ./src/components/order/MainRecurringOrder/index.jsx